import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 12px 12px 0px 0px;
  font-weight: 500;
  line-height: 21px;
  color: #ffffff;
  font-size: 14px;
  padding: 14px 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 14px 21px;
  }
`

const Basic = styled.div`
  display: flex;
  grid-column: span 4;
`

const No = styled.span`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    width: 20px;
  }
`

const Symbol = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    grid-column: span 1;
  }
`

const APR = styled.div`
  text-align: right;
  grid-column: span 1;
`

const TotalStaked = styled.div`
  text-align: right;
  grid-column: span 3;

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-column: span 2;
  }
`

const PoolsHeader: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeaderContainer>
        <Basic>
          <No>#</No> {t('Basic Info')}
        </Basic>
        <Symbol>{t('Symbol')}</Symbol>
        <APR>{t('APR')}</APR>
        <TotalStaked>{t('Total Staked')}</TotalStaked>
      </HeaderContainer>
    </>
  )
}

export default PoolsHeader
